import { render, staticRenderFns } from "./OpcServerFormDialog.vue?vue&type=template&id=07cb9b96"
import script from "./OpcServerFormDialog.vue?vue&type=script&lang=js"
export * from "./OpcServerFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports